export const adminAccessMap = {
  root_admin: 'all',
  mid_admin: 'all',
  order_admin: [
    '/admin_dashboard/home',
    '/admin_dashboard/orders',
    '/admin_dashboard/chat',
    '/admin_dashboard/home',
    '/admin_dashboard/support_chat',
    '/admin_dashboard/customers',
  ],
  product_admin: [
    '/admin_dashboard/product',
    '/admin_dashboard/home',
    '/admin_dashboard/category',
    '/admin_dashboard/major_category',
    '/admin_dashboard/brand',
  ],
  normal_admin: [
    '/admin_dashboard/home',
    '/admin_dashboard/review',
    '/admin_dashboard/macue',
    '/admin_dashboard/blogs',
    '/admin_dashboard/reels',
  ],
};

export const menuItems = [
  {
    path: '/admin_dashboard/home',
    icon: 'solar:widget-5-bold-duotone',
    text: 'Dashboard',
  },
  {
    path: '/admin_dashboard/category',
    icon: 'solar:clipboard-list-bold-duotone',
    text: 'Category',
  },
  {
    path: '/admin_dashboard/major_category',
    icon: 'solar:clipboard-list-bold-duotone',
    text: 'Major Category',
  },
  {
    path: '/admin_dashboard/brand',
    icon: 'solar:clipboard-list-bold-duotone',
    text: 'Brand',
  },
  {
    path: '/admin_dashboard/review',
    icon: 'solar:chat-square-like-bold-duotone',
    text: 'Review',
  },
  {
    path: '/admin_dashboard/macue',
    icon: 'solar:clipboard-list-bold-duotone',
    text: 'Macue',
  },

  {
    path: '/admin_dashboard/product',
    icon: 'solar:t-shirt-bold-duotone',
    text: 'Products',
  },
  {
    path: '/admin_dashboard/orders',
    icon: 'solar:bag-smile-bold-duotone',
    text: 'Orders',
  },
  {
    path: '/admin_dashboard/chat',
    icon: 'solar:chat-round-bold-duotone',
    text: 'Order Chat',
  },
  {
    path: '/admin_dashboard/support_chat',
    icon: 'solar:chat-round-bold-duotone',
    text: 'Support Chat',
  },
  {
    path: '/admin_dashboard/admins',
    icon: 'solar:user-speak-rounded-bold-duotone',
    text: 'Admins',
  },
  {
    path: '/admin_dashboard/customers',
    icon: 'solar:users-group-two-rounded-bold-duotone',
    text: 'Customers',
  },
  {
    path: '/admin_dashboard/blogs',
    icon: 'solar:document-text-bold-duotone',
    text: 'Blogs',
  },
  {
    path: '/admin_dashboard/reels',
    icon: 'solar:clipboard-list-bold-duotone',
    text: 'Reels',
  },
];
